<div id="exportar-pdf">
  <section>
    <app-cabecalho-relatorio></app-cabecalho-relatorio>
    <app-rotulo-cabecalho [cliente]="relatorio?.cabecalho?.nomeCliente"
      [contrato]="relatorio?.cabecalho?.contratoCliente" [cnpj]="relatorio?.cabecalho?.cnpjCliente"
      [tipoDeContrato]="relatorio?.cabecalho?.tipoContratoCliente"
      [mesReferencia]="relatorio?.cabecalho?.vencimento?.mesReferencia"
      [vencimento]="relatorio?.cabecalho?.vencimento?.dataMes "
      [faturaNumero]="relatorio?.cabecalho?.vencimento?.numeroFatura" [valor]="relatorio?.cabecalho?.valorFatura"
      [dataEmissao]="relatorio?.cabecalho?.vencimento?.dataEmissao"
      [emissao]="relatorio?.cabecalho?.vencimento?.emissao">
    </app-rotulo-cabecalho>
  </section>
  <div *ngFor="let detalhe of relatorio?.detalhamento">
    <app-tabela-relatorio [equipamento]="detalhe?.nomeEquipamento"
      [cabecalhosTabela]="['PATRIMÔNIO', 'DESCRIÇÃO', 'VALOR TX. FIXA', 'ANT P&B', 'ATU P&B', 'SALDO P&B', 'VALOR PAG. P&B', 'VALOR PROD P&B', 'ANT COR', 'ATU COR', 'SALDO COR', 'VALOR PAG. COR', 'VALOR PROD COR', 'VALOR TOTAL', 'DATA LEIT.', 'CONTATO']">
      <tr *ngFor="let detalhesTabela of detalhe.informacoesTabela">
        <ng-container class="cabecalho__tabela">
          <td class="item__tabela">{{ detalhesTabela.patrimonio }}</td>
          <td class="item__detalhamento">{{ detalhesTabela.equipamento }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorTxFixa }}</td>
          <td class="item__tabela">{{ detalhesTabela.antPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.atuPB }}</td>
          <td class="item__tabela">{{ detalhesTabela.saldoPB }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorPagPb }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorProdPb }}</td>
          <td class="item__tabela">{{ detalhesTabela.antCor }}</td>
          <td class="item__tabela">{{ detalhesTabela.atuCor }}</td>
          <td class="item__tabela">{{ detalhesTabela.saldoCor }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorPagCor }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorProdCor }}</td>
          <td class="item__tabela">R$ {{ detalhesTabela.valorTotal }}</td>
          <td class="item__tabela">{{ detalhesTabela.dataLeit | date: "dd/MM/yyyy"}}</td>
          <td class="item__tabela">{{ detalhesTabela.contato }}</td>
        </ng-container>
      </tr>
    </app-tabela-relatorio>
    <app-rodape-tabela-relatorios [tipoRelatorio]="relatorio?.cabecalho?.razaoNotaFiscalRelatorioTipo">
    </app-rodape-tabela-relatorios>
  </div>
  <app-rodape-relatorio [valorTotalDaFatura]="relatorio?.resumoTotal?.valorTotalFatura">
    <div class="resumo__total__container">
      <div class="espaco__um">
        <span class="titulo__resumo">VALOR TAXA FIXA</span>
        <p class="informacao__dado">R$ {{ relatorio?.resumoTotal?.valorTaxaFixa }}</p>
      </div>
      <div>
        <span class="titulo__resumo">IMPRESSÕES PRODUZIDAS</span>
        <div>
          <div class="itens__combo">
            <span class="titulo__resumo__item">P&B: </span>
            <p class="informacao__dado"> {{ relatorio?.resumoTotal?.impressoesProduzidasPb }}</p>
          </div>
          <div class="itens__combo">
            <span class="titulo__resumo__item">COLOR: </span>
            <p class="informacao__dado"> {{ relatorio?.resumoTotal?.impressoesProduzidasCor }}</p>
          </div>
        </div>
      </div>
      <div class="espaco__tres">
        <span class="titulo__resumo">VALOR TOTAL PRODUÇÃO</span>
        <div>
          <div class="itens__combo">
            <span class="titulo__resumo__item">P&B: </span>
            <p class="informacao__dado"> R$ {{ relatorio?.resumoTotal?.valorTotalProducaoPb }} </p>
          </div>
          <div class="itens__combo">
            <span class="titulo__resumo__item">COLOR: </span>
            <p class="informacao__dado"> R$ {{ relatorio?.resumoTotal?.valorTotalProducaoCor }}</p>
          </div>
        </div>
      </div>
    </div>
  </app-rodape-relatorio>
